module.exports = __webpack_public_path__ + "img/Lift.5aaaf455.svg";